import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import NavigationCard from 'Components/ComponentLibrary/Components/Uncategorized/NavigationCard';
import LogoutButton from 'Views/Onboarding/Components/Navigation/LogoutButton';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { dashboardUri } from 'Consts/clientUris';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { useNavigationContext } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';


const styles = theme => ({
  content: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${theme.palette.facet.accentGray}`,
  },
  exit: {
    marginTop: 'auto',
  },
  logout: {
    marginTop: theme.spacing(2),
  },
  secondaryText: {
    color: theme.palette.facet.mediumDarkGray,
    fontSize: theme.typography.fontSizePt75Rem,
  },
  primaryText: {
    color: theme.palette.facet.primaryGray,
  },
});

const WizardNavigationContent = ({
  classes,
  resource,
  isOpen,
}) => {
  const history = useHistory();
  const { loadPageLink, setOpen } = useNavigationContext();

  async function handleClick(link) {
    try {
      await loadPageLink(link);
    } catch (err) {
      displayErrorMessage(err, 'Failed to load page');
    }
    setOpen(false);
  }

  return (
    <React.Fragment>
      <div className={classes.content} test="wizard-navigation-content">
        {resource.attr('navigations').resources().list().map(el => {
          const isDisabled = el.attr('isDisabled') === 'true';
          const isComplete = el.attr('isComplete') === 'true';
          return (
            <NavigationCard
              className={classes.card}
              key={`nav-card-${el.id()}`}
              compact={!isOpen}
              onClick={isDisabled ? undefined : () => handleClick(el.relationship('link').link('related'))}
              id={el.id()}
              primaryText={el.attr('title')}
              secondaryText={el.attr('subtitle')}
              estimatedDuration={0}
              isComplete={isComplete}
              isDisabled={isDisabled}
              isInProgress={!isComplete && !isDisabled}
            />
          );
        })}
        <NavigationCard
          classes={{
            secondaryText: classes.secondaryText,
            primaryText: classes.primaryText,
          }}
          className={classNames(classes.card, classes.exit)}
          key={'nav-card-exit'}
          compact={!isOpen}
          onClick={() => {
            const exitRelationship = resource?.relationship(fr.relationships.exit.name)?.link('related');
            if (!exitRelationship) {
              return history.push(dashboardUri);
            }
            return handleClick(exitRelationship);
          }}
          id={'exit'}
          primaryText={resource.attr('exitText')}
          secondaryText={'Your progress will be saved'}
        />
      </div>
      <div className={classes.logout}>
        <LogoutButton compact={!isOpen} />
      </div>
    </React.Fragment>
  );
};

WizardNavigationContent.defaultProps = {
  isOpen: false,
};

WizardNavigationContent.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
};

export default withStyles(styles)(WizardNavigationContent);
